<!-- src/app/settings/accruals/pages/leave-policies/leave-policies.component.html -->
<accruals-nav></accruals-nav>

<div class="leave-policies-container">
    <!-- Loading -->
    <div *ngIf="isLoading" class="spinner-container">
        <div class="spinner"></div>
    </div>

    <!-- Error -->
    <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
    </div>

    <!-- Header -->
    <div class="header" *ngIf="!isLoading">
        <h2>Leave Policies</h2>

        <div class="header-actions">
            <button class="btn btn-primary" (click)="openCreatePolicyModal()">
                + New Policy
            </button>
        </div>
    </div>

    <!-- Policy Sections -->
    <ng-container *ngIf="!isLoading">
        <div class="policies-columns">
            <!-- Vacation Column -->
            <section class="policy-section vacation-section">
                <div class="section-header">
                    <div class="section-title-wrap">
                        <h3>Vacation Policies</h3>
                        <span class="section-badge vacation">{{ vacationPolicies.length }}</span>
                    </div>
                </div>

                <div class="policies-list" *ngIf="vacationPolicies.length > 0; else noVacationPolicies">
                    <div *ngFor="let policy of vacationPolicies; trackBy: trackByPolicyId" class="policy-row vacation">
                        <div class="policy-info clickable" (click)="goToPolicyDetail(policy)">
                            <div class="policy-name-row">
                                <div class="policy-name">{{ policy.name }}</div>
                                <span class="leave-type-badge vacation">{{ policy.leaveType }}</span>
                            </div>

                            <div class="policy-meta">
                                <span>Frequency: {{ policy.accrualFrequency }}</span>
                                <span>Hours/Year: {{ policy.hoursPerYear }}</span>
                                <span>Max Balance: {{ policy.maxBalance }}</span>
                                <span>Carry Over: {{ policy.maxCarryOver }}</span>
                                <span>{{ policy.allowNegativeBalance ? 'Negative Allowed' : 'No Negative Balance'
                                    }}</span>
                            </div>

                            <div class="policy-description">
                                Weekly Accrual Day: {{ policy.weeklyAccrualDay || 'N/A' }}
                            </div>
                        </div>

                        <div class="policy-actions">
                            <button class="btn view" (click)="goToPolicyDetail(policy)">
                                View
                            </button>
                            <button class="btn assign" (click)="openAssignPolicyModal(policy)">
                                Assign
                            </button>
                        </div>
                    </div>
                </div>

                <ng-template #noVacationPolicies>
                    <div class="empty-state">
                        No vacation policies found.
                    </div>
                </ng-template>
            </section>

            <!-- Sick Column -->
            <section class="policy-section sick-section">
                <div class="section-header">
                    <div class="section-title-wrap">
                        <h3>Sick Policies</h3>
                        <span class="section-badge sick">{{ sickPolicies.length }}</span>
                    </div>
                </div>

                <div class="policies-list" *ngIf="sickPolicies.length > 0; else noSickPolicies">
                    <div *ngFor="let policy of sickPolicies; trackBy: trackByPolicyId" class="policy-row sick">
                        <div class="policy-info clickable" (click)="goToPolicyDetail(policy)">
                            <div class="policy-name-row">
                                <div class="policy-name">{{ policy.name }}</div>
                                <span class="leave-type-badge sick">{{ policy.leaveType }}</span>
                            </div>

                            <div class="policy-meta">
                                <span>Frequency: {{ policy.accrualFrequency }}</span>
                                <span>Hours/Year: {{ policy.hoursPerYear }}</span>
                                <span>Max Balance: {{ policy.maxBalance }}</span>
                                <span>Carry Over: {{ policy.maxCarryOver }}</span>
                                <span>{{ policy.allowNegativeBalance ? 'Negative Allowed' : 'No Negative Balance'
                                    }}</span>
                            </div>

                            <div class="policy-description">
                                Weekly Accrual Day: {{ policy.weeklyAccrualDay || 'N/A' }}
                            </div>
                        </div>

                        <div class="policy-actions">
                            <button class="btn view" (click)="goToPolicyDetail(policy)">
                                View
                            </button>
                            <button class="btn assign" (click)="openAssignPolicyModal(policy)">
                                Assign
                            </button>
                        </div>
                    </div>
                </div>

                <ng-template #noSickPolicies>
                    <div class="empty-state">
                        No sick policies found.
                    </div>
                </ng-template>
            </section>
        </div>
    </ng-container>

    <!-- Create Policy Modal -->
    <app-create-leave-policy-modal [open]="createModalOpen" [isSaving]="isSavingPolicy"
        [filterValues]="leavePolicyFilterValues" (close)="closeCreatePolicyModal()"
        (save)="onCreatePolicy($event)"></app-create-leave-policy-modal>

    <!-- Assign Policy Modal -->
    <div *ngIf="assignModalOpen" class="modal-backdrop" (click)="closeAssignPolicyModal()">
        <div class="modal assign-modal" (click)="$event.stopPropagation()">
            <h2>Assign Policy</h2>

            <p class="modal-text" *ngIf="selectedPolicyForAssignment">
                Assign <strong>{{ selectedPolicyForAssignment.name }}</strong> to one or more employees.
            </p>

            <div class="assignment-form">
                <label class="form-field">
                    <span>Start Date</span>
                    <input type="date" [(ngModel)]="assignmentStartDate" />
                </label>

                <div class="assignment-filters">
                    <label class="filter-field search-field">
                        <span>Search Employee</span>
                        <input type="text" [(ngModel)]="assignmentSearchInputValue"
                            (ngModelChange)="onAssignmentSearchChange($event)"
                            placeholder="Search name, employee #, or email" />
                    </label>

                    <label class="filter-field">
                        <span>Company</span>
                        <select [(ngModel)]="assignmentFilters.companyId"
                            (ngModelChange)="onAssignmentCompanyChange($event)">
                            <option [ngValue]="null">All companies</option>
                            <option *ngFor="let company of userFilterValues?.companies" [ngValue]="company.id">
                                {{ company.name }}
                            </option>
                        </select>
                    </label>

                    <label class="filter-field">
                        <span>Department</span>
                        <select [(ngModel)]="assignmentFilters.departmentId"
                            (ngModelChange)="onAssignmentDepartmentChange($event)">
                            <option [ngValue]="null">All departments</option>
                            <option *ngFor="let dept of userFilterValues?.departments" [ngValue]="dept.id">
                                {{ dept.code }} - {{ dept.name }}
                            </option>
                        </select>
                    </label>

                    <div class="filter-actions">
                        <button class="clear-filters-btn" type="button" (click)="clearAssignmentFilters()"
                            [disabled]="!hasAssignmentFilters">
                            Clear Filters
                        </button>
                    </div>
                </div>

                <div class="assignment-summary">
                    {{ assignmentSelectedCount }} employee{{ assignmentSelectedCount === 1 ? '' : 's' }} selected
                </div>

                <div class="employee-select-list">
                    <div *ngFor="let employee of filteredAssignableUsers; trackBy: trackByEmployeeId"
                        class="employee-select-row" [class.selected]="isEmployeeSelected(employee.id)"
                        (click)="toggleEmployeeSelection(employee.id)">
                        <div class="employee-select-info">
                            <div class="employee-name-row">
                                <div class="employee-name">
                                    {{ employee.firstName }} {{ employee.lastName }}
                                </div>
                                <div class="employee-number">
                                    #{{ employee.employeeNumber }}
                                </div>
                            </div>

                            <div class="employee-meta">
                                <span>{{ employee.company?.name || 'No company' }}</span>
                                <span>{{ employee.department?.code || '—' }} {{ employee.department?.name || ''
                                    }}</span>
                                <span *ngIf="employee.email">{{ employee.email }}</span>
                            </div>
                        </div>

                        <div class="employee-select-check">
                            <input type="checkbox" [checked]="isEmployeeSelected(employee.id)"
                                (click)="$event.stopPropagation()" (change)="toggleEmployeeSelection(employee.id)" />
                        </div>
                    </div>

                    <div *ngIf="filteredAssignableUsers.length === 0" class="empty-state compact">
                        No employees match the current filters.
                    </div>
                </div>
            </div>

            <div class="modal-buttons">
                <button type="button" class="btn btn-secondary" (click)="closeAssignPolicyModal()"
                    [disabled]="isAssigningPolicy">
                    Cancel
                </button>

                <button type="button" class="btn btn-primary" (click)="assignSelectedEmployees()"
                    [disabled]="isAssigningPolicy">
                    {{ isAssigningPolicy ? 'Saving...' : 'Assign Policy' }}
                </button>
            </div>
        </div>
    </div>

    <!-- Toast -->
    <div *ngIf="toastVisible" class="toast" [ngClass]="toastType">
        <img class="icon" alt="icon" />
        <span>{{ toastMessage }}</span>
    </div>
</div>